import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

const brandingPage = PageBlueprint.make({
  params: {
    path: '/branding',
    routeRef: rootRouteRef,
    title: 'Branding',
    loader: () =>
      import('./components/BrandingPage').then(m => <m.BrandingPage />),
  },
});

export const brandingPlugin = createFrontendPlugin({
  pluginId: 'branding',
  routes: {
    root: rootRouteRef,
  },
  extensions: [brandingPage],
});

export default brandingPlugin;
